// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismroserodesarrollador@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyCqjVAZDOV1CPhMt6Ryz8IBn4F0EL4SiNc",
    authDomain: "cafe-origenes.firebaseapp.com",
    projectId: "cafe-origenes",
    storageBucket: "cafe-origenes.firebasestorage.app",
    messagingSenderId: "200900457943",
    appId: "1:200900457943:web:b6e72c276d2a24fe3cc792",
    measurementId: "G-719JQGKXP8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)